<ng-template [ngIf]="false">
  <!--
  @see https://www.figma.com/file/3Al7WB7BIaZbcOXYlk2gz5/Lingo-Production-2?node-id=178%3A9219&viewport=7176%2C671%2C0.6818868517875671
  -->
</ng-template>

<div class="vocabulary-options">
  <h2 class="title bold">Выберите слова, которые хотите изучить</h2>

  <div class="terms">
    <div *ngFor="let option of termOptions; let idx = index; trackBy: trackByFn" class="term-wrap">
      <div class="term">
        <label class="label">
          <input type="checkbox" class="input" [checked]="option.is_checked" (change)="option.is_checked = !option.is_checked">
          <span class="input-icon-wrap">
            <app-icon icon="checkbox-arrow" class="input-icon"></app-icon>
          </span>
        </label>

        <div class="term-content">
          <span class="term-word normal">{{ option.term.term }}</span>
          <div class="voice-icon-wrap">
            <app-icon class="voice-icon" width="16" height="14" icon="no-voice"></app-icon>
          </div>
        </div>
      </div>

      <div class="term term--right">
        <div class="term-content">
          <div class="voice-icon-wrap">
            <app-icon class="voice-icon" width="16" height="14" icon="no-voice"></app-icon>
          </div>
          <span class="term-word normal">{{ option.term.definition }}</span>
        </div>
      </div>
    </div>
  </div>

  <pre *ngIf="false">{{ termOptions | json }}</pre>

  <div class="footer">
    <div class="info normal">Выбранные слова можно добавить в свой словарь для изучения их позже</div>
    <div class="buttons">
      <on-ui-button class="secondary outline"
                    label="Добавить в словарь">
      </on-ui-button>

      <on-ui-button [state]="saveButton"
                    class="secondary"
                    [label]="saveAndPlayTitle | translate: { 'count': selectedTermsCount }"
                    (click)="saveAndPlay()"
      ></on-ui-button>
    </div>
  </div>
</div>
